export const CUSTOM_SHIFT_CODE = "custom";
export const OFF_SHIFT_CODE = "off";
export const WORKTABLE_UNDECIDED_SYMBOL = "？";
export const WORKTABLE_UNREGISTERED_SYMBOL = "—";

export const SHIFT_PRESETS_BY_STORE = {
  kasama: [
    {
      code: "day_0830_1730",
      label: "8:30〜17:30",
      startTime: "08:30",
      endTime: "17:30",
      endDayOffset: 0,
    },
    {
      code: "day_0900_1730",
      label: "9:00〜17:30",
      startTime: "09:00",
      endTime: "17:30",
      endDayOffset: 0,
    },
    {
      code: "day_0900_1700",
      label: "9:00〜17:00",
      startTime: "09:00",
      endTime: "17:00",
      endDayOffset: 0,
    },
    {
      code: "day_0930_1600",
      label: "9:30〜16:00",
      startTime: "09:30",
      endTime: "16:00",
      endDayOffset: 0,
    },
    {
      code: "day_1000_1500",
      label: "10:00〜15:00",
      startTime: "10:00",
      endTime: "15:00",
      endDayOffset: 0,
    },
    {
      code: "day_1000_1730",
      label: "10:00〜17:30",
      startTime: "10:00",
      endTime: "17:30",
      endDayOffset: 0,
    },
    {
      code: "night_1700_0900",
      label: "17:00〜翌9:00（夜勤）",
      shiftValue: "17:00〜翌9:00",
      startTime: "17:00",
      endTime: "09:00",
      endDayOffset: 1,
    },
  ],
  ami: [
    {
      code: "day_0830_1730",
      label: "8:30〜17:30",
      startTime: "08:30",
      endTime: "17:30",
      endDayOffset: 0,
    },
    {
      code: "night_1700_0900",
      label: "17:00〜翌9:00（夜勤）",
      shiftValue: "17:00〜翌9:00",
      startTime: "17:00",
      endTime: "09:00",
      endDayOffset: 1,
    },
  ],
  "re-five": [
    {
      code: "day_0830_1730",
      label: "8:30〜17:30",
      startTime: "08:30",
      endTime: "17:30",
      endDayOffset: 0,
    },
    {
      code: "day_0900_1700",
      label: "9:00〜17:00",
      startTime: "09:00",
      endTime: "17:00",
      endDayOffset: 0,
    },
  ],
};

const TIME_PATTERN = /^(?:[01]\d|2[0-3]):[0-5]\d$/;

export function usesStructuredShiftEditor(storeId) {
  return Object.prototype.hasOwnProperty.call(SHIFT_PRESETS_BY_STORE, storeId);
}

export function getShiftPreset(storeId, code) {
  return (SHIFT_PRESETS_BY_STORE[storeId] || []).find(preset => preset.code === code) || null;
}

export function isStructuredShift(row) {
  if (isDayOffShift(row)) return true;
  return Boolean(
    row &&
    row.user_id &&
    row.shift_date &&
    row.start_time &&
    row.end_time &&
    row.end_day_offset !== null &&
    row.end_day_offset !== undefined &&
    row.preset_code
  );
}

export function isDayOffShift(row) {
  return Boolean(
    row &&
    row.user_id &&
    row.shift_date &&
    row.preset_code === OFF_SHIFT_CODE &&
    !row.start_time &&
    !row.end_time
  );
}

export function normalizeTime(value) {
  return typeof value === "string" ? value.slice(0, 5) : "";
}

export function formatShiftValue(startTime, endTime, endDayOffset) {
  const start = normalizeTime(startTime).replace(/^0(?=\d:)/, "");
  const end = normalizeTime(endTime).replace(/^0(?=\d:)/, "");
  return `${start}〜${Number(endDayOffset) === 1 ? "翌" : ""}${end}`;
}

export function getShiftDisplayValue(row) {
  if (!row) return "";
  if (isDayOffShift(row)) return "休み";
  return isStructuredShift(row)
    ? formatShiftValue(row.start_time, row.end_time, row.end_day_offset)
    : row.shift_value || "";
}

export function getShiftWorktableSymbol(row) {
  if (!row) return WORKTABLE_UNREGISTERED_SYMBOL;
  if (row.preset_code === OFF_SHIFT_CODE) return "/";
  if (row.preset_code === "night_1700_0900") return "■";
  if (typeof row.preset_code === "string" && row.preset_code.startsWith("day_")) return "○";
  return WORKTABLE_UNDECIDED_SYMBOL;
}

export function validateCustomShift({ startTime, endTime, endDayOffset }) {
  if (!startTime) return "開始時刻を入力してください";
  if (!endTime) return "終了時刻を入力してください";
  if (!TIME_PATTERN.test(startTime) || !TIME_PATTERN.test(endTime)) {
    return "時刻を正しい形式で入力してください";
  }
  if (![0, 1].includes(Number(endDayOffset))) {
    return "翌日終了の指定が正しくありません";
  }

  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [endHour, endMinute] = endTime.split(":").map(Number);
  const start = startHour * 60 + startMinute;
  const end = endHour * 60 + endMinute + Number(endDayOffset) * 24 * 60;

  if (Number(endDayOffset) === 0 && end <= start) {
    return end === start
      ? "同日勤務では開始時刻と終了時刻を同じにできません"
      : "終了が翌日になる場合は「翌日終了」を選択してください";
  }
  if (end - start <= 0 || end - start > 24 * 60) {
    return "勤務時間は24時間以内で入力してください";
  }
  return "";
}

function addDays(dateString, days) {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day + days));
  return date.toISOString().slice(0, 10);
}

export function calculateScheduledDateTimes({ shiftDate, startTime, endTime, endDayOffset }) {
  return {
    scheduledStartAt: `${shiftDate} ${normalizeTime(startTime)}`,
    scheduledEndAt: `${addDays(shiftDate, Number(endDayOffset))} ${normalizeTime(endTime)}`,
  };
}

export function getShiftEditorInitialState(row, storeId) {
  if (!isStructuredShift(row)) {
    return {
      presetCode: "",
      startTime: "",
      endTime: "",
      endDayOffset: 0,
      legacyValue: row?.shift_value || "",
    };
  }

  if (isDayOffShift(row)) {
    return {
      presetCode: OFF_SHIFT_CODE,
      startTime: "",
      endTime: "",
      endDayOffset: 0,
      legacyValue: "",
    };
  }

  const candidatePreset = getShiftPreset(storeId, row.preset_code);
  const preset = candidatePreset
    && candidatePreset.startTime === normalizeTime(row.start_time)
    && candidatePreset.endTime === normalizeTime(row.end_time)
    && candidatePreset.endDayOffset === Number(row.end_day_offset)
    ? candidatePreset
    : null;
  return {
    presetCode: preset ? preset.code : CUSTOM_SHIFT_CODE,
    startTime: normalizeTime(row.start_time),
    endTime: normalizeTime(row.end_time),
    endDayOffset: Number(row.end_day_offset),
    legacyValue: "",
  };
}

export function buildStructuredShiftPayload({ storeId, staff, shiftDate, presetCode, startTime, endTime, endDayOffset }) {
  if (presetCode === OFF_SHIFT_CODE) {
    return {
      store_id: storeId,
      user_id: staff.id,
      staff_name: staff.name,
      shift_date: shiftDate,
      start_time: null,
      end_time: null,
      end_day_offset: null,
      preset_code: OFF_SHIFT_CODE,
      year_month: shiftDate.slice(0, 7),
      day_of_week: shiftDate,
      shift_value: "休み",
    };
  }

  const preset = getShiftPreset(storeId, presetCode);
  const values = preset || {
    code: CUSTOM_SHIFT_CODE,
    startTime,
    endTime,
    endDayOffset: Number(endDayOffset),
  };

  return {
    store_id: storeId,
    user_id: staff.id,
    staff_name: staff.name,
    shift_date: shiftDate,
    start_time: values.startTime,
    end_time: values.endTime,
    end_day_offset: values.endDayOffset,
    preset_code: values.code,
    year_month: shiftDate.slice(0, 7),
    day_of_week: shiftDate,
    shift_value: preset?.shiftValue || preset?.label || formatShiftValue(values.startTime, values.endTime, values.endDayOffset),
  };
}
